import type { JSX } from 'react';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})) as typeof TableRow;

interface Entry {
  readonly action?: JSX.Element;
  readonly id: string;
  readonly label: string;
  readonly value: string | number | JSX.Element;
  readonly valueAlign?: 'left' | 'right';
}

interface Props {
  readonly ariaLabel: string;
  readonly dense?: boolean;
  readonly entries: readonly Readonly<Entry>[];
}

export const KeyValueTable = ({
  ariaLabel,
  dense = false,
  entries,
}: Readonly<Props>) => (
  <TableContainer component={Paper}>
    <MuiTable aria-label={ariaLabel} size={dense ? 'small' : 'medium'}>
      <TableBody>
        {entries.map(
          ({ id, label, valueAlign, value, action }: Readonly<Entry>) => (
            <StyledTableRow key={id}>
              <TableCell component="th" scope="row">
                {label}
              </TableCell>
              <TableCell align={valueAlign ?? 'left'}>{value}</TableCell>
              {!!action && <TableCell align="center">{action}</TableCell>}
            </StyledTableRow>
          ),
        )}
      </TableBody>
    </MuiTable>
  </TableContainer>
);
